const TOKEN_KEY = 'dashboard:token';
const USER_KEY = 'dashboard:user';
const ACTIVE_USER_KEY = 'dashboard:active-user';
const SELECTED_COMPANY_KEY = 'dashboard:selected-company';
const LOGOUT_EVENT = 'dashboard:logout';

function hasStorage() {
  return typeof window !== 'undefined' && window.localStorage;
}

export function getToken() {
  if (!hasStorage()) return null;
  return window.localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
  if (!hasStorage()) return null;
  const raw = window.localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn('[Session] Failed to parse stored user payload', error);
    window.localStorage.removeItem(USER_KEY);
    return null;
  }
}

export function getActiveUser() {
  if (!hasStorage()) return null;
  const raw = window.localStorage.getItem(ACTIVE_USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn('[Session] Failed to parse stored active user payload', error);
    window.localStorage.removeItem(ACTIVE_USER_KEY);
    return null;
  }
}

export function storeSession(token, user) {
  if (!hasStorage()) return;
  window.localStorage.setItem(TOKEN_KEY, token);
  window.localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function storeActiveUser(user) {
  if (!hasStorage()) return;
  if (!user) {
    window.localStorage.removeItem(ACTIVE_USER_KEY);
    return;
  }
  window.localStorage.setItem(ACTIVE_USER_KEY, JSON.stringify(user));
}

export function getSelectedCompanyId() {
  if (!hasStorage()) return null;
  const raw = window.localStorage.getItem(SELECTED_COMPANY_KEY);
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!trimmed) {
    window.localStorage.removeItem(SELECTED_COMPANY_KEY);
    return null;
  }
  return trimmed;
}

export function storeSelectedCompanyId(companyId) {
  if (!hasStorage()) return;
  if (companyId === null || companyId === undefined) {
    window.localStorage.removeItem(SELECTED_COMPANY_KEY);
    return;
  }
  window.localStorage.setItem(SELECTED_COMPANY_KEY, String(companyId));
}

export function clearSession() {
  if (!hasStorage()) return;
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(USER_KEY);
  window.localStorage.removeItem(ACTIVE_USER_KEY);
  window.localStorage.removeItem(SELECTED_COMPANY_KEY);
}

export function notifyLogout() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(LOGOUT_EVENT));
}

export const Session = {
  getToken,
  getUser,
  getActiveUser,
  getSelectedCompanyId,
  storeSession,
  storeActiveUser,
  storeSelectedCompanyId,
  clearSession,
  notifyLogout,
  LOGOUT_EVENT,
};
